import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const WaterFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="waterFilled" ref={ref} {...props}>
      <path d="M11.89,2.25a.81.81,0,0,1,.6.3C13,3.12,18,9.25,18,14.7c0,4.35-2.36,7.05-6.15,7.05s-6.15-2.7-6.15-7c0-5.45,5.06-11.57,5.55-12.15A.81.81,0,0,1,11.89,2.25Z" />
    </Icon>
  ),
) as IconWithRender;

WaterFilledIcon.displayName = 'WaterFilledIcon';
WaterFilledIcon.renderIcon = (props) => <WaterFilledIcon {...props} />;
export default WaterFilledIcon;
